import api from '@/api'
import status from '@/utils/status'
import format from '@/utils/format'
import tableHeaders from '@/utils/tableHeaders'
import options from '@/utils/options'

const state = {
	sampleInfo: {
		
	},
	sampleList: [],
	viewSpecimen: {
		headers: [],
		list: [],
	},
	viewCategory: {
		headers: [],
		list: []
	},
	testList: [
		{
			type: '',
			sampleCollectTime: [''],
			testList: []
		}
	],
	sampleDetail: [],
	//시료 입력
	sampleForm: {
		sampleName: "",
		sampleDeliveryWay: "",
		sampleTestMethod: "",
		sampleCount: 0,
		sampleCollector: "",
		sampleCollectDate: "",
		sampleDescription: "",
		sampleContainer: '',
		sampleVolume: '',
		testDetail: {
			list: []
		},
		testList: [],
		updateDatetime: '',
		sampleExpire: '',
	},
	testCategory: {
		list: [],
		type: ''
	}
}

const getters = {
	sampleInfo: state => state.sampleInfo,
	sampleList: state => state.sampleList,
	testList: state => state.testList,
	sampleForm: state => state.sampleForm,
	sampleDetail: state => {
		let list = []
		status.project_detail.sample.forEach(item => {
			let value = format.dataValue(item.key, state.sampleDetail);
			if (item.key === 'sampleCount' && state.sampleDetail.pluralSampleCount > 0) {
				const total = Number(value) || 0;
				const plural = state.sampleDetail.pluralSampleCount;
				value = `${total - plural} (+복수시료 ${plural}개)`;
			}
			list.push({
				key: item.key,
				name: item.name,
				value,
				type: item.type
			})
		})
		return list;
	},
	testCategory: state => state.testCategory,
	viewSpecimen: state => {
		state.viewSpecimen.headers = state.viewSpecimen.headers.map(header => {
			header.key = header.testId
			return header
		})
		state.viewSpecimen.list = state.viewSpecimen.list.map(el => {
			el.soilDepth = el.additional?.soil_depth;
			return el;
		})
		return state.viewSpecimen
	},
	viewCategory: state => {
		state.viewCategory.headers = state.viewCategory.headers.map(header => {
			header.key = header.headerKey
			header.label = header.text ? header.text: header.name
			header.formatter = (value, key, item) => {
				return format.dataValue(key, item)
			}
			return header
		})
		return state.viewCategory
	}
}

const mutations = {
	setSampleInfo: (state, data) => {
		state.sampleInfo = {...data}
		state.sampleDetail = {...data}
	},
	setSampleList: (state, data) => {
		state.viewSpecimen.list = [];
		state.sampleList = [];
		state.viewSpecimen.headers = [...tableHeaders.testInfoTableHeaders.map(header => {
			header.key = header.headerKey
			header.label = header.text
			return header
		}), ...state.testCategory.list.map(header => {
			header.key = header.testId
			header.headerKey = header.testId
			header.label = options.testHeaderSearchNameIds.includes(header.testId) ? header.search_name : header.name
			header.original_name = header.original_name
			header.name = header.name
			return header
		})]
		state.viewSpecimen.list = [...data]
		state.viewCategory.headers = tableHeaders.categoryTestInfoTableHeaders
		state.viewCategory.list = [...data]
		state.sampleList = [...data]
	},
	setTest: (state, data) => {
		state.testList = [...data]
	},
	resetTestList: (state) => {
		state.testList = [
			{
				type: '',
				testList: []
			}
		];
		state.viewSpecimen = {
			headers: [],
			list: [],
		}
	},
	setTestCategory: (state, data) => {
		state.testCategory = {...data}
	},
	resetForm: (state) => {
		let result = {...state.form}
		let keys = Object.keys(result)
		keys.forEach(key => {
			result[key] = ''
			if(typeof result === 'object') {
				result[key].list = []
			}
		})
		state.sampleInfo = result;
		state.form = result;
	}
}

const actions = {
	//시료 정보 가져오기
	loadSampleInfo: async ({state, commit}, id) => {
		const res = await api.project.getSample(id)
		commit('setSampleInfo', res)
	},
	//시료 리스트 가져오기
	loadSampleList: async ({commit, dispatch}, payload) => {
		const {id, isGroup} = payload
		const res = await api.project.getSampleList(id, isGroup)
		commit('setSampleList', res)
	},
	//시료 생성 & 수정하기
	updateSample: async({commit}, payload) => {
		const {id, body} = payload
		const res = await api.project.updateSample(id, body)
		return res
	},
	//시험 정보 가져오기
	loadTest: async ({commit}, payload) => {
		// 숫자 id 도 받는다. 종전에는 문자열만 id 로 보고 숫자(등록 직후 $router.push 의 params.id)를
		// 옵션 객체로 오해해 `/project/undefined/sample/test` 를 조회 → 빈 목록 (2026-09-10 운영 확인:
		// 이전업무 불러오기 직후 시료 화면이 비고, 새로고침(문자열 id)하면 정상).
		const isOptions = payload !== null && typeof payload === 'object';
		const id = isOptions ? payload.id : payload;
		const filterPhenol = isOptions ? (payload.filterPhenol ?? false) : false;
		if (id === undefined || id === null || id === '') throw new Error('시료 정보를 불러오지 못했습니다. 다시 열어 주세요.')
		const res = await api.project.getTest(id, { filterPhenol })
		if (!Array.isArray(res)) throw new Error('시료 정보를 불러오지 못했습니다. 다시 열어 주세요.')
		await commit('resetTestList')
		await commit('setTest', res)
	},
	//시험 정보 입력 (등록, 수정)
	updateTest: async ({commit, dispatch}, payload) => {
		const {id, body} = payload;
		const res = await api.project.updateTest(id, body)
		return res
	},
	//시험일지 - 페놀류 시료별 시험방법 변경 (WATER_TEST_027/102)
	updatePhenolMethod: async (_, payload) => {
		const { projectId, body } = payload;
		const res = await api.project.updatePhenolMethod(projectId, body)
		return res
	},
	loadTestCategory: async ({state, commit}, id, order = "") => {
		const res = await api.project.getCategory(id, order)
		commit('setTestCategory', res)
	}
}

export default { namespaced: true, state, getters, mutations, actions }